import { render, staticRenderFns } from "./CompanyWizard.vue?vue&type=template&id=74b4f7c8&scoped=true"
import script from "./CompanyWizard.vue?vue&type=script&lang=ts"
export * from "./CompanyWizard.vue?vue&type=script&lang=ts"
import style0 from "./CompanyWizard.vue?vue&type=style&index=0&id=74b4f7c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b4f7c8",
  null
  
)

export default component.exports